import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

const ProgressBox = () => (
  <Box display="flex" justifyContent="center">
    <CircularProgress size="3rem" />
  </Box>
);

export { ProgressBox };
